import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}><g id="✅-Mobile" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Group-25" fill="#FFF"><path id="Rectangle-5-Copy-3" transform="rotate(45 8 8)" d="M-2 7h20v2H-2z" /><path id="Rectangle-5-Copy-5" transform="scale(1 -1) rotate(45 27.31 0)" d="M-2 7h20v2H-2z" /></g></g></svg>);